import { useEffect } from 'react';

/**
 * Custom hook to prevent scrolling on a target element when a condition is met
 * @param isActive - Whether scroll prevention should be active
 * @param targetElement - The element to apply overflow hidden to (defaults to document.body)
 */
export const usePreventScroll = (
  isActive: boolean,
  targetElement: HTMLElement = document.body
) => {
  useEffect(() => {
    if (isActive) {
      const originalOverflow = targetElement.style.getPropertyValue('overflow');
      const originalPriority =
        targetElement.style.getPropertyPriority('overflow');

      // Use !important to override any existing styles
      targetElement.style.setProperty('overflow', 'hidden', 'important');

      return () => {
        if (originalOverflow) {
          targetElement.style.setProperty(
            'overflow',
            originalOverflow,
            originalPriority
          );
        } else {
          targetElement.style.removeProperty('overflow');
        }
      };
    }
  }, [isActive, targetElement]);
};
